export default __webpack_public_path__ + "static/media/time.07db9d8d.svg";